/**
 * Media query breakpoints
 *
 * Check with #design before you add anything.
 * Keep in sync with src/styles/settings/_breakpoints.scss
 */
export enum FreelancerBreakpoints {
  MOBILE_SMALL = '(min-width: 400px)',
  MOBILE = '(min-width: 480px)',
  TABLET = '(min-width: 768px)',
  DESKTOP_SMALL = '(min-width: 960px)',
  DESKTOP_LARGE = '(min-width: 1200px)',
  DESKTOP_XLARGE = '(min-width: 1440px)',
  DESKTOP_XXLARGE = '(min-width: 1600px)',
  DESKTOP_XXXLARGE = '(min-width: 1920px)',
  DESKTOP_XXXXLARGE = '(min-width: 2560px)',
}

export const enum FreelancerBreakpointValues {
  MOBILE_SMALL = '400px',
  MOBILE = '480px',
  TABLET = '768px',
  DESKTOP_SMALL = '960px',
  DESKTOP_LARGE = '1200px',
  DESKTOP_XLARGE = '1440px',
  DESKTOP_XXLARGE = '1600px',
  DESKTOP_XXXLARGE = '1920px',
  DESKTOP_XXXXLARGE = '2560px',
}

export const enum FreelancerMaxBreakpoint {
  MOBILE_SMALL = '(max-width:399.9px)',
  MOBILE = '(max-width:479.9px)',
  TABLET = '(max-width:767.9px)',
  TABLET_LANDSCAPE = '(max-height:600px)',
  DESKTOP_SMALL = '(max-width:959.9px)',
  DESKTOP_LARGE = '(max-width:1199.9px)',
  DESKTOP_XLARGE = '(max-width:1439.9px)',
  DESKTOP_XXLARGE = '(max-width:1599.9px)',
  DESKTOP_XXXLARGE = '(max-width:1919.9px)',
  DESKTOP_XXXXLARGE = '(max-width:2559.9px)',
}
